import Auth from "@/services/ExerciseAuth"
import Http from "@/services/api/util/http-internal"
import Repo from "@/services/api/util/auth-repo-local-storage"

const instance = new Auth(new Repo(), new Http(), process.env.VUE_APP_EXERCISE_API)
Object.freeze(instance)
export default instance